
<div class="flow-radio-group">
	<div
		v-for="option in options"
		:key="option.key"
		:data-selected="option.selected"
		class="flow-radio-group-option"
		@click="toggle(option)"
	>
		<slot name="option" :option="option">
			<Typography v-if="option.label" type="p2" color="light">{{ option.label }}</Typography>
		</slot>
	</div>
</div>
